<template>
  <v-hover v-slot="{ hover }">
    <v-card
      class="mr-4 d-flex align-center justify-center card-current-thumb"
      height="92px"
      @click="$emit('select')"
      :ripple="false"
    >
      <template v-if="thumb && !loadingDelete">
        <div
          :class="`thumb-preview${selected ? '--selected' : ''}`"
          :style="`background: url(${thumb});`"
        ></div>
      </template>
      <template v-else-if="!loadingDelete">
        <v-img
          max-width="50"
          max-height="50"
          src="@/assets/pandaHappy.svg"
        ></v-img>
      </template>

      <div class="align-self-center" v-if="showCloseBtn">
        <v-btn
          filter
          icon
          class="btn-handle-delete"
          :class="{ 'show-btn-handle-delete': hover }"
          @click="handleDeleteThumbnail"
        >
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </div>
      <v-progress-circular
        v-if="loadingDelete"
        :size="22"
        width="3"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  name: 'previewThumbCard',
  props: {
    thumb: {
      type: String,
      required: false,
    },
    showCloseBtn: {
      type: Boolean,
      required: true,
    },
    loadingDelete: {
      type: Boolean,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleDeleteThumbnail() {
      this.$emit('delete')
    },
  },
}
</script>

<style lang="scss">
.btn-handle-delete {
  opacity: 0;
  position: absolute;
  bottom: 67px;
  left: 134px;
  background: #282525;
  height: 30px !important;
  width: 30px !important;
}

.btn-handle-delete span i {
  color: #fff !important;
  height: 17px !important;
  font-size: 17px !important;
  width: 19px !important;
}

.show-btn-handle-delete {
  opacity: 1 !important;
}

.thumb-preview {
  height: 92px;
  width: 150px;
  background-size: cover !important;
  background-position: 50% 50% !important;
  background-repeat: no-repeat !important;
  border-radius: 4px;

  &--selected {
    @extend .thumb-preview;
    border: 2px solid var(--v-brand-base);
  }
}

.card-current-thumb {
  border: 1px solid #d0d1d9;
  border-color: #d0d1d9 !important;
  min-width: 150px !important;
  max-width: 150px !important;
}
</style>
